<template>
  <div id="ebOrder">
    <span v-for="(item, key) in orderDatas" :key="key">
      <span @click="setOrderContent(key,item.adesc);setClass($event)"> {{item.text}}</span>
      <i @click="setOrderContent(key,item.adesc);setClass($event)" class="icon iconfont icon-xiangxiajiantou" :class="item.upOrDownClass"></i>
    </span>
  </div>
</template>
<script>
import $ from 'jquery';
export default {
  name: 'ebOrder',
  props: ['orderData'],
  data() {
    return {
      orderDatas: this.orderData
    };
  },
  methods: {
    setOrderContent: function(orderContent, adesc) {
      if (adesc === null || adesc === 'asc') {
        this.orderDatas[orderContent]['adesc'] = 'desc';
      } else {
        this.orderDatas[orderContent]['adesc'] = 'asc';
      }
      var str = orderContent + '' + this.orderDatas[orderContent]['adesc'];
      this.$emit('getOrderData', str);
    },
    setClass: function(event) {
      $(event.target)
        .parent('span')
        .addClass('text-orange')
        .siblings()
        .removeClass('text-orange')
        .parent('span')
        .find('i')
        .removeClass('icon-xiangshangjiantou')
        .addClass('icon-xiangxiajiantou');
      if (
        $(event.target)
          .parent('span')
          .find('i')
          .hasClass('icon-xiangxiajiantou')
      ) {
        $(event.target)
          .parent('span')
          .find('i')
          .removeClass('icon-xiangxiajiantou')
          .addClass('icon-xiangshangjiantou');
      } else {
        $(event.target)
          .parent('span')
          .find('i')
          .removeClass('icon-xiangshangjiantou')
          .addClass('icon-xiangxiajiantou');
      }
    }
  }
};
</script>
<style scoped lang="less">
#ebOrder {
  color:#010101;
  font-size: 12px;
  line-height: 42px;
  i {
    margin: 0 10px 0 5px;
    font-size:12px;
  }
  .text-orange {
    color: #fb5b3b;
  }
  span {
    cursor: pointer;
  }
}
</style>
